import styled from "styled-components";

export const RowView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &.top {
    align-items: flex-start;
  }
  &.bottom {
    align-items: flex-end;
  }
  &.center {
    justify-content: center;
  }
  &.pointer {
    cursor: pointer;
  }
`;
export const RowView2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  &.none {
    display: none;
  }
  &.top {
    align-items: flex-start;
  }
  &.end {
    justify-content: flex-end;
  }
  &.center {
    justify-content: center;
  }
  &.nowrap {
    white-space: nowrap;
  }
  &.pointer {
    cursor: pointer;
  }
  &.col {
    flex-direction: column;
  }
`;
export const CenterView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  &.col {
    flex-direction: column;
  }
`;

// 모달
export const BackgroundArea = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;
export const TitleArea = styled(RowView)`
  box-sizing: border-box;
  margin-bottom: 1rem;
  div {
    font-family: var(--font-Pretendard-Bold);
    font-size: 20px;
  }
  img {
    cursor: pointer;
  }
`;

/* ----- 라디오 버튼 -----*/
export const CheckRadio = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 1.25em;
  height: 1.25em;
  border: 1px solid #e6e6e6;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  &:checked {
    background-color: #00d2ad;
    border: 3px solid white;
    box-shadow: 0 0 0 1px #e6e6e6;
  }
`;

/* ----- 체크박스 -----*/
export const CheckBox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 1.3rem;
  height: 1.3rem;
  border: 1px solid #e6e6e6;
  border-radius: 3px;
  background-color: white;
  outline: none;
  cursor: pointer;
  &:checked {
    border-color: #252525;
    background-color: #252525;
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  &.red {
    width: 1.5rem;
    height: 1.5rem;
    &:checked {
      border-color: #ea2922;
      background-color: #ea2922;
    }
  }
`;

/* ----- 아이콘 -----*/
export const Icon = styled.img`
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  &.gray {
    opacity: 0.3;
  }
  &.btn {
    cursor: pointer;
  }
`;
